import React from 'react';
import PropTypes from 'prop-types';
import { Cushion, Rectangle, Shadow, Typography } from '@pitchero/react-ui';
import { Trans } from '../../lib/i18n';
import Selection from './selection';

const TeamLineup = ({ teamName, starters, substitutes, teamId }) => (
  <div>
    <Shadow shadow="dark">
      <Rectangle
        fill="white"
        component="div"
        responsive={[{ minWidth: 'fullHeader', props: { radius: 'rounded' } }]}
        style={{ overflow: 'hidden' }}
      >
        <Rectangle fill="#000">
          <Cushion vertical="small" horizontal="medium">
            <Typography preset="title" size={16} color="#fff" component="div">
              {teamName}
            </Typography>
          </Cushion>
        </Rectangle>
        {starters.map((selection) => (
          <Selection key={selection.id} {...selection} teamId={teamId} />
        ))}
        {substitutes.length > 0 && (
          <>
            <Rectangle fill="#eee">
              <Cushion vertical="small" horizontal="medium">
                <Typography preset="title" size={16} color="#000" component="div">
                  <Trans i18nKey="teams:substitutes_title">Substitutes</Trans>
                </Typography>
              </Cushion>
            </Rectangle>
            {substitutes.map((selection) => (
              <Selection key={selection.id} {...selection} teamId={teamId} />
            ))}
          </>
        )}
      </Rectangle>
    </Shadow>
  </div>
);

TeamLineup.propTypes = {
  teamName: PropTypes.string.isRequired,
  starters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      avatar: PropTypes.string,
      name: PropTypes.string,
      number: PropTypes.number,
    }),
  ).isRequired,
  substitutes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      avatar: PropTypes.string,
      name: PropTypes.string,
      number: PropTypes.number,
    }),
  ).isRequired,
  teamId: PropTypes.number.isRequired,
};

export default TeamLineup;
